import script from "./StepJoining.vue?vue&type=script&setup=true&lang=js"
export * from "./StepJoining.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import SelectInput from "@/components/neue/SelectInput.vue";
import SelectionCard from "@/components/neue/wizard/SelectionCard.vue";
import SelectionGroup from "@/components/neue/wizard/SelectionGroup.vue";
import ToggleRow from "@/components/neue/wizard/ToggleRow.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { HighlightedText, SelectInput, SelectionCard, SelectionGroup, ToggleRow, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { HighlightedText, SelectInput, SelectionCard, SelectionGroup, ToggleRow, WizardSection }, script.__o.components);}